import { RootState } from '@/store';
import { createSelector } from '@reduxjs/toolkit';
import { LLMTemplateVariablesState, SLICE_NAME } from './models';

const llmTemplateVariablesSelector = (state: RootState): LLMTemplateVariablesState => state[SLICE_NAME];

export const selectLLMTemplateVariables = createSelector(
  llmTemplateVariablesSelector,
  (state: LLMTemplateVariablesState) => state.variables,
);

export const selectLLMTemplateVariablesIsLoading = createSelector(
  llmTemplateVariablesSelector,
  (state: LLMTemplateVariablesState) => state.isLoading,
);

export const selectLLMTemplateVariablesError = createSelector(
  llmTemplateVariablesSelector,
  (state: LLMTemplateVariablesState) => state.error,
);
